import Marquee from "react-fast-marquee";
import { TESTIMONIALS, MEDIA } from "@/data/content";
import { Quotes } from "@phosphor-icons/react";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/10 overflow-hidden"
    >
      {/* Background texture */}
      <div className="absolute inset-0 opacity-30">
        <img
          src={MEDIA.textureBg}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-[#050505]/70" />
      </div>

      {/* Kinetic outline text */}
      <div className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 text-center select-none">
        <span className="font-display uppercase text-[22vw] leading-none text-outline-strong whitespace-nowrap">
          On The Record
        </span>
      </div>

      <div className="relative px-6 md:px-12 lg:px-24 mb-14 md:mb-20 max-w-4xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E50914] mb-6">
          // 05 — On The Record
        </p>
        <h2
          data-testid="testimonials-title"
          className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9]"
        >
          What artists <br /> say about us.
        </h2>
      </div>

      <div className="relative">
        <Marquee gradient={false} speed={28} pauseOnHover autoFill>
          {TESTIMONIALS.map((t, i) => (
            <article
              key={`${t.name}-${i}`}
              data-testid={`testimonial-${i}`}
              className="mx-4 w-[320px] md:w-[440px] shrink-0 bg-[#0d0d0d] border border-white/10 hover:border-white/25 transition-colors duration-300 p-7 md:p-9"
            >
              <Quotes size={28} weight="fill" className="text-[#E50914] mb-5" />
              <p className="text-zinc-200 text-base md:text-lg leading-relaxed mb-7">
                {t.quote}
              </p>
              <div className="flex items-center justify-between border-t border-white/10 pt-5">
                <div>
                  <div className="font-display uppercase text-white text-lg leading-none">
                    {t.name}
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500 mt-2">
                    {t.role}
                  </div>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-600">
                  0{i + 1}
                </div>
              </div>
            </article>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
